import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { TaskPriority } from '@repo/contracts';

import type { RootState } from './store';

interface BoardFiltersState {
  assigneeId: string | null;
  priority: TaskPriority | 'all';
  onlyMine: boolean;
}

const initialState: BoardFiltersState = { assigneeId: null, priority: 'all', onlyMine: false };

const boardFiltersSlice = createSlice({
  name: 'boardFilters',
  initialState,
  reducers: {
    assigneeChanged: (state, action: PayloadAction<string | null>) => {
      state.assigneeId = action.payload;
    },
    priorityChanged: (state, action: PayloadAction<TaskPriority | 'all'>) => {
      state.priority = action.payload;
    },
    onlyMineToggled: (state) => {
      state.onlyMine = !state.onlyMine;
    },
  },
});

export const { assigneeChanged, priorityChanged, onlyMineToggled } = boardFiltersSlice.actions;
export const boardFiltersReducer = boardFiltersSlice.reducer;

export const selectBoardFilters = (state: RootState): BoardFiltersState => state.boardFilters;

export const selectBoardQuery = (state: RootState) => {
  const { assigneeId, priority, onlyMine } = state.boardFilters;
  const resolvedAssignee = onlyMine ? (state.auth.user?.id ?? null) : assigneeId;

  return {
    ...(resolvedAssignee ? { assigneeId: resolvedAssignee } : {}),
    ...(priority === 'all' ? {} : { priority }),
  };
};
